exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.app-body {\n\toverflow-x: unset;\n}\n.header-fixed .app-header {\n\tz-index: 1021;\n}\n.sidenav-sticky {\n\ttop: 68px;\n}\n.btn-link.collapse-btn {\n\tcolor: #323635;\n\ttext-align: left;\n\tpadding-left: 0;\n\tpadding-right: 0;\n\tclear: both;\n\ttransition: all 0.4s;\n}\n.btn-link.collapse-btn:hover,\n.btn-link.collapse-btn:active,\n.btn-link.collapse-btn:focus {\n\tpadding-left: 8px;\n\tbackground-color: #f3f4f5;\n\ttext-decoration: none;\n}\n.btn-link.collapse-btn i {\n\tfloat: right;\n\tmargin: 6px 12px 0 0;\n\tfont-size: 0.7rem;\n}\n", ""]);

// exports
